import { post } from './http'

//获取各分院体育教育挂科率分析
export function getCollegeSportFailRate() {
    return post('/tyapi/pc/learningCockpit/getCollegeSportFailRate', {})
}

//获取各分院课程成绩预警数据
export function getCollegeGradeWarn() {
    return post('/tyapi/pc/learningCockpit/getCollegeGradeWarn', {})
}

//获取重点关注学生
export function getFocusOnStudents() {
    return post('/tyapi/pc/learningCockpit/getFocusOnStudents', {})
}

//获取预警人数
export function getWarningNumber() {
    return post('/tyapi/pc/learningCockpit/getWarningNumber', {})
}

//获取各课程预警人数
export function getCourseWarningNumber() {
    return post('/tyapi/pc/learningCockpit/getCourseWarningNumber', {})
}

//获取各年级预警人数
export function getGradeWarningNumber() {
    return post('/tyapi/pc/learningCockpit/getGradeWarningNumber', {})
}